<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/association-introduction">关于我们</router-link></li>
                <li class="currentNode"><a>申请入会</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>关于我们</a></li>
                    <li><router-link to="/layout/association-introduction">协会简介</router-link></li>
                    <li><router-link to="/layout/association-articles">协会章程</router-link></li>
                    <li><router-link to="/layout/association-structure">协会构架</router-link></li>
                    <li><router-link to="" class="active">申请入会</router-link></li>
                    <li><router-link to="/layout/call">联系方式</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>申请入会</h3>
                    <el-form label-width="100px" :model="form" :rules="rules" ref="ruleForm" class="form" size="small">
                        <el-form-item label="单位名称" prop="company">
                            <el-input v-model="form.company"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人" prop="name">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="tel">
                            <el-input v-model="form.tel"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="onSubmit" class="submitBtn">提交</el-button>
                        </el-form-item>
                    </el-form>           
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getXiehuiModel,
    addContact,
} from '@services/indexService.js'
import rulesPattern from '@/assets/utils/rulesPattern.js';
export default {
    name:"",
    data() {
        return {
            id: 5, // 5
            content: "",
            form: {
                company: "",
                name: "",
                tel: ""
            },
            rules: {
                name: [
                    { required: true, message: '请输入联系人', trigger: 'blur' },
                    { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' },
                ],
                tel: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    { pattern: rulesPattern.phoneAndTel, message: '请输入正确的手机号或者座机号格式为：0000-0000000', trigger: 'blur' }
                ],
            }
        }
    },
    created() {
    },
    methods: {
        getXiehuiModel() {
            let params = {
                id: this.id
            };
            getXiehuiModel(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.content = res.Data.Industry;
                } else {
                    this.content = "";
                    this.$message.error("协会简介请求失败");
                }
            })
        },
        addContact() {
            let params = {
                BuyerPhone: this.form.tel,
                BuyerName: this.form.name,
                City: this.form.company
            };
            addContact(params).then(res => {
                if (res.Code == 1) {
                    this.$message.success(`欢迎${this.form.name}成功申请入会!`);
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        onSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.addContact();
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px;
}
.page-content h3{
    text-align:center;
    margin-bottom: 20px;
}
.form{
    width: 450px;
    margin: 0 auto;
}
.el-button:focus, .el-button:hover {
    color: #fff;
    border-color: #005091;
    background-color: #005091;
}
</style>